import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { Hilo } from 'src/app/models/hilo';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-dailyhilo-dinamic-backtest',
  standalone: true,
  templateUrl: './dailyhilo-dinamic-backtest.component.html',
  styleUrls: ['./dailyhilo-dinamic-backtest.component.scss'],
  imports: [MdbTableModule, CommonModule, ReactiveFormsModule,
    MdbFormsModule, MdbSelectModule
  ]
})
export class DailyhiloDinamicBacktestComponent implements OnInit {

  dati: Hilo[] = []
  markets: any = []
  headers = ['Market', 'Day Of Week', 'Versus', 'Type', 'Num', 'Profit', '% Pos.', 'Profit/Num(PIP)', 'Rawal'];
  tableData: any = [];
  formFiltri: FormGroup = new FormGroup({
    selMarket: new FormControl(null),
    selDayweek: new FormControl(null),
    selRawal: new FormControl(null)
  })
  days: any = [
    { value: 1, label: 'Lunedì' },
    { value: 2, label: 'Martedì' },
    { value: 3, label: 'Mercoledì' },
    { value: 4, label: 'Giovedì' },
    { value: 5, label: 'Venerdì' }
  ]
  rawals: any = [
    {value: 0},
    {value: 1},
    {value: 2},
    {value: 3},
  ]

  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.service.getMarketsSymbols().subscribe((data: any) => {
      this.markets = data['data'];
    })
    this.service.getDailyBangRawal().subscribe((data: any) => {
      console.log(data)
      this.dati = data['data']
      this.dati = this.dati.filter((item: any) => item.profit > 0)
      this.dati.map((item: any) => {
        item.giorno = this.days.find((gg: any) => gg.value== item.dayweek).label
        item.rawal = (item.sumpos/item.numpos)/((item.sumpos-item.profit)/(item.num-item.numpos))
        item.percpos = item.numpos/item.num*100
        item.profitpip = item.profit/item.num/item.pip
      })
      this.tableData = this.dati
    })

  }

  filtraDati() {
    let mkt = this.formFiltri.get('selMarket')?.value
    let day = this.formFiltri.get('selDayweek')?.value
    let raw = this.formFiltri.get('selRawal')?.value
    console.log(mkt, day)
    let lst = (mkt != 'all' && mkt != null) ? this.dati.filter((item: any) => item.market == mkt) : this.dati
    lst = day > 0 ? lst.filter((item: any) => item.dayweek == day) : lst
    lst = raw > 0 ? lst.filter((item: any) => item.rawal>raw) : lst
    this.tableData = lst
  }

  nomeGiorno(id: number) {
    let elem = this.days.find((d: any) => d.value == id)
    return elem ? elem.label : id
  }
  calcolaBT() {

  }

}
